<template>
  <button class="d-flex flex-row fwd-orange restart-container align-items-center" @click="$emit('restart')">
    <img src="./assets/restart-icon.svg" alt="" class="restart-icon">
    <div class="restart-text">
      {{t('button.restart')}}
    </div>
  </button>
</template>

<script>
import { useI18n } from "vue-i18n";
export default {
  setup() {
    const {t} = useI18n();
    return {
      t
    }
  },
  emits: ['restart']
}
</script>

<style scoped>
.restart-container {
  gap: 3px;
}
.restart-icon {
  width: 24px;
  height: 24px;
}
.restart-text {
  font-size: 14px;
}
button {
  background: none;
  border: none;
}
@media (max-width: 768px) {
  .restart-text {
    font-size: 12px;
  }
  .restart-icon {
    width: 15px;
    height: 15px;
  }
}
</style>